import * as Sentry from '@sentry/react'
import React from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom'

import { SENTRY_DSN } from '../constants/sentry'

Sentry.init({
  dsn: SENTRY_DSN,
  enableLogs: true,
  sendDefaultPii: true,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    Sentry.zodErrorsIntegration(),
    Sentry.dedupeIntegration()
  ]
})

Sentry.setTag('app-version', __APP_VERSION__)
